import { Button, Stack, Typography } from '@mui/material';
import React, { ComponentProps, useState } from 'react';

import { EsriAttribute } from '../../../api/ach/esri';
import AiAudienceSearch from '../../CustomSegments/AiAudienceSearch';
import FormEndOptions from '../../forms/FormEndOptions';
import EsriLocationBuilder, {
  EsriLocationBuilderProps,
} from '../TargetingLocations/EsriLocationBuilder/EsriLocationBuilder';

type EsriTarget = Pick<EsriLocationBuilderProps, 'adGroupId' | 'adGroupName' | 'lineItemId' | 'momentsType'>;

interface Props {
  onUseSegment: ComponentProps<typeof AiAudienceSearch>['onUseSegment'];
  // Omitted when ESRI picks can't be attached (an unsaved or exclusion list).
  esriTarget?: EsriTarget;
  onClose: () => void;
}

function AiAudienceSearchModal({ onUseSegment, esriTarget, onClose }: Props) {
  const [esri, setEsri] = useState<{ attributes: EsriAttribute[]; query: string } | null>(null);

  return (
    <Stack sx={{ minWidth: '80vw', minHeight: '70vh' }} justifyContent="space-between">
      {/* Hidden rather than unmounted so Back returns to the same search. */}
      <Stack sx={{ display: esri ? 'none' : 'block' }}>
        <Stack p={2} spacing={2}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Search by AI Description
          </Typography>
          <AiAudienceSearch
            onUseSegment={onUseSegment}
            onUseEsriAttributes={esriTarget ? (attributes, query) => setEsri({ attributes, query }) : undefined}
          />
        </Stack>
      </Stack>
      <FormEndOptions sx={{ display: esri ? 'none' : 'block' }}>
        <Stack direction="row" justifyContent="center" width="100%" spacing={2}>
          <Button variant="outlined" onClick={onClose}>
            Close
          </Button>
        </Stack>
      </FormEndOptions>
      {esri && esriTarget && (
        <EsriLocationBuilder
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...esriTarget}
          initialAttributes={esri.attributes}
          initialNamePrefix={esri.query}
          onBack={() => setEsri(null)}
          onClose={onClose}
        />
      )}
    </Stack>
  );
}

export default AiAudienceSearchModal;
